export const data = {
	title: '¿No podés esperar a tener <br/>tu Fiat Strada?',
	description: '',
	legal: 'La disponibilidad de artículos de serie, opcionales y accesorios puede variar de acuerdo a la versión exhibida.<br/>Verifique en el Configurador. Las imágenes son meramente ilustrativas.<br/>FCA AUTOMOBILES ARGENTINA S.A. CUIT 30-68245096-3. CARLOS M. DELLA PAOLERA 299, PISO 25, CABA. IMAGENES NO CONTRACTUALES. LA IMAGEN Y EQUIPAMIENTO CORRESPONDEN A FIAT STRADA VERSION VOLCANO. LAS LLANTAS DE LA VERSIÓN EN IMAGEN DE 16" SON OPCIONALES. ORIGEN DEL PRODUCTO: BRASIL. ELVIS PRESLEY™; RIGHTS OF PUBLICITY AND PERSONA RIGHTS: ELVIS PRESLEY ENTERPRISES, LLC. ELVIS.COM. PARA MAYOR INFORMACIÓN, INGRESAR EN: WWW.NUEVASTRADA.COM.AR O COMUNICARSE GRATUITAMENTE AL 0800-777-8000.',
	list:
	[
		{
			label: 'ELEGÍ LA TUYA',
			href: 'https://fiat.com.ar/contactenos?type=191',
			dataLayerId: 'FooterPage_ClicouAgendeSeuTesteDrive',
		},
		{
			label: 'CONFIGURADOR',
			href: 'https://fiat.com.ar/configurador/191',
			target: '_blank',
		},
	  {
		label: 'FICHA TÉCNICA',
		href: '../../assets/ft.pdf',
			target: '_blank',
		}, 
	],
	social:
	[
		{
			label: 'facebook',
			href: 'https://www.facebook.com/fiatargentina',
			target: '_blank',
		},
		{
			label: 'youtube',
			href: 'https://www.youtube.com/user/FiatAutoArgentina',
			target: '_blank',
		},
		{
			label: 'twitter',
			href: 'https://twitter.com/fiatargentina',
			target: '_blank',
		},
		{
			label: 'instagram',
			href: 'https://www.instagram.com/fiatargentina/',
			target: '_blank',
		},
	],
};

export default data;
